var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWizard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6664 5.33333L13.9998 4L13.3331 5.33333L11.9998 5.5L13.1118 6.444L12.6664 8L13.9998 7.112L15.3331 8L14.8878 6.444L15.9998 5.5L14.6664 5.33333ZM25.7784 19.5547L24.6664 17.3333L23.5544 19.5547L21.3331 19.8333L23.1851 21.408L22.4451 24L24.6664 22.5187L26.8878 24L26.1478 21.408L27.9998 19.8333L25.7784 19.5547ZM8.88909 8.444L7.99976 6.66667L7.11043 8.444L5.33309 8.66667L6.81443 9.92533L6.22242 12L7.99976 10.8147L9.77709 12L9.18509 9.92533L10.6664 8.66667L8.88909 8.444ZM4.55176 22.6667C4.55176 23.3787 4.82909 24.048 5.33309 24.552L7.44776 26.6667C7.95176 27.1707 8.62109 27.448 9.33309 27.448C10.0451 27.448 10.7144 27.1707 11.2184 26.6667L26.6664 11.2187C27.1704 10.7147 27.4478 10.0453 27.4478 9.33333C27.4478 8.62133 27.1704 7.952 26.6664 7.448L24.5518 5.33333C23.5438 4.32533 21.7891 4.32533 20.7811 5.33333L5.33309 20.7813C4.82909 21.2853 4.55176 21.9547 4.55176 22.6667ZM22.6664 7.21867L24.7811 9.33333L19.9998 14.1147L17.8851 12L22.6664 7.21867Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWizard);
export default __webpack_public_path__ + "static/media/wizard.57dbe2fef8fa12a65c024eea2378acf0.svg";
export { ForwardRef as ReactComponent };